module.exports = __webpack_public_path__ + "static/media/42.67b9841a.jpg";